import React, { useState } from "react";
import { isMobile } from "react-device-detect";
const CustomSearchForm = ({ isEnglish, isMenuBar }) => {
  const [query, setQuery] = useState("");
  const [isCseLoaded, setIsCseLoaded] = useState(false);
  const [scriptLoading, setScriptLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const loadCSEScript = () => {
    return new Promise((resolve) => {
      if (isCseLoaded || window.google?.search?.cse?.element) {
        resolve();
        return;
      }
      let cscId = !isEnglish ? "4484a1e9c853b48fa" : "65270f36524b44566";
      setScriptLoading(true);
      const script = document.createElement("script");
      script.src = "https://cse.google.com/cse.js?cx=" + cscId;
      script.async = true;
      script.onload = () => {
        setIsCseLoaded(true);
        setScriptLoading(false);
        resolve();
      };
      document.body.appendChild(script);
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      setErrorMessage(isEnglish ? "Please enter a search term." : "يرجى إدخال كلمة للبحث.");
      return;
    }
    setErrorMessage("");
    setIsLoading(true);
    const isDev = window.location.hostname === "localhost";
    const collectionName = isDev ? "searchQueriesDev" : "searchQueries";
    try {
      const { db } = await import("../firebaseConfig");
      const { collection, addDoc, serverTimestamp } = await import("firebase/firestore");
      await addDoc(collection(db, collectionName), {
        query: trimmedQuery,
        createdAt: serverTimestamp(),
      });
    } catch (error) {
      console.error("Error storing search query:", error);
    }
    await loadCSEScript();
    const interval = setInterval(() => {
      const element = window.google?.search?.cse?.element?.getElement("searchresults-only0");
      if (element) {
        clearInterval(interval);
        element.execute(trimmedQuery);
        setIsLoading(false);
      }
    }, 100);
  };
  return (
    <div className="container" style={{ width: "100%", direction: isEnglish ? "ltr" : "rtl" }}>
      <style>
        {`
          #pageSearchBox::placeholder {
            color: #999 !important;
            opacity: 1 !important;
          }
          #pageSearchBox::-webkit-input-placeholder {
            color: #999 !important;
            opacity: 1 !important;
          }
          #pageSearchBox::-moz-placeholder {
            color: #999 !important;
            opacity: 1 !important;
          }
          #pageSearchBox:-ms-input-placeholder {
            color: #999 !important;
            opacity: 1 !important;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <form onSubmit={handleSubmit} style={{ display: "flex", justifyContent: "center", margin: 0 }}>
        <div style={{ position: "relative", width: isMobile ? "100%" : "80%" }}>
          <input
            type="text"
            name="q"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            id="pageSearchBox"
            placeholder={isMenuBar ? (isEnglish ? "Search..." : "ابحث عن حاسبة..") : (isEnglish ? "Search for calculator..." : "ابحث عن حاسبة...")}
            enterKeyHint="search"
            style={{
              width: "100%",
              padding: isMenuBar
                ? "8px 12px"
                : isEnglish
                  ? "16px 68px 16px 20px"
                  : "16px 20px 16px 68px",
              height: isMenuBar ? "46px" : "56px",
              fontSize: "16px",
              borderRadius: isMenuBar ? "23px" : "16px",
              border: isMenuBar ? "2px solid rgba(255,255,255,0.3)" : "1px solid #e0e0e0",
              backgroundColor: isMenuBar ? "#ffffff" : "#fff",
              color: "#000000",
              marginTop: "0px",
              WebkitTextFillColor: "#000000",
              opacity: 1,
              boxShadow: isMenuBar ? "none" : "0 2px 8px rgba(0,0,0,0.08)",
              transition: "all 0.2s ease",
            }}
            onFocus={(e) => {
              if (!isMenuBar) {
                e.currentTarget.style.border = "1px solid #16a085";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(22,160,133,0.15)";
              }
            }}
            onBlur={(e) => {
              if (!isMenuBar) {
                e.currentTarget.style.border = "1px solid #e0e0e0";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
              }
            }}
          />
          {!isMenuBar && (
            <button
              type="submit"
              disabled={scriptLoading || isLoading}
              style={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                left: isEnglish ? "unset" : "16px",
                right: isEnglish ? "16px" : "unset",
                width: "40px",
                height: "40px",
                borderRadius: "12px",
                backgroundColor: "#16a085",
                border: "none",
                cursor: scriptLoading || isLoading ? "wait" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1,
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                if (!scriptLoading && !isLoading) {
                  e.currentTarget.style.backgroundColor = "#138d75";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#16a085";
              }}
              aria-label={isEnglish ? "Search" : "بحث"}
            >
              {isLoading ? (
                <div style={{
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderTop: "2px solid white",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  animation: "spin 0.6s linear infinite"
                }} />
              ) : (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              )}
            </button>
          )}
        </div>
      </form>
      {errorMessage && (
        <div style={{ color: "red", marginTop: "8px", fontSize: "14px", textAlign: isEnglish ? "left" : "right", justifyContent: "center", display: "flex" }}>
          {errorMessage}
        </div>
      )}
      <div style={{ marginTop: isMenuBar ? "0px" : "30px" }}>
        <div className="gcse-searchresults-only" id="searchresults-only0" />
      </div>
    </div>
  );
};
export default CustomSearchForm;